import * as _ from 'lodash'
import {CustomerHierarchyBO} from "./CustomerHierarchyBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_CustomerHierarchyRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Customer_Hierarchy} from "../PA.Core/PAdbSchema";


export class CustomerHierarchyBOValidations {


    static async ValidateFields(aBO: CustomerHierarchyBO): Promise<void> {

        let dbContext = new PAdbContext({})


        // Validate Customer Hierarchy Name
        if (_.isEmpty(aBO.WB_CustomerHierarchy.cif.WB_CUST_HIER_NAME)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'EmptyName',
                    type: MessageType.Error,
                    title: "Customer Hierarchy Name cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        } else {
            aBO.ValidateMessageProvider.removeMessage('EmptyName')
        }

        if (_.isEmpty(aBO.WB_CustomerHierarchy.cif.WB_CUST_HIER_ID)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'EmptyID',
                    type: MessageType.Error,
                    title: "Customer Hierarchy ID cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        } else {
            aBO.ValidateMessageProvider.removeMessage('EmptyID')
        }


        // Customer Hierarchies are considered duplicates only within the same Master Data Set
        let custHRows: WB_CustomerHierarchyRow[] = await dbContext.findAll(esWB_Customer_Hierarchy,
            {where: {DELETED_IND: {neq: '1'},
                    WB_CUSTH_ID: {neq: aBO.WB_CustomerHierarchy.cif.WB_CUSTH_ID},
                    WB_MDSET_ID: aBO.WB_CustomerHierarchy.cif.WB_MDSET_ID,
                    WB_CUST_HIER_ID: aBO.WB_CustomerHierarchy.cif.WB_CUST_HIER_ID}})



        if (!_.isEmpty(custHRows)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "duplicateID", type: MessageType.Error,
                title: 'Existing Customer Hierarchy with the same ID: ' +
                    '\nCustomer Hierarchy: ' + _.map(custHRows, (a) => `${a.cif.WB_CUST_HIER_NAME} (${a.cif.WB_CUST_HIER_ID})`).join(","),
                description: "",
                subtitle: "",
                count: 0
            })
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateID")
        }



    }
}
